import styled from 'styled-components'

export const ModalBodyText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #363636;
`
